<script>
// 引用 Multiselect 套件&css，此套件@close為'關閉下拉菜單時發出的事件(onTouch)'
// 觸發onTouch後將選擇的部門資料，透過$emit在父層methods的SelectDept()，接收參數(this.ApplyDeptId)
// 父層的watch 監控部門變數(this.ApplyDeptId)，觸發API查詢該部門資料。
import Multiselect from 'vue-multiselect'
import { apiDeptid } from '../../Api/api'
export default {
  props: { // 接收父層資料，空為String，有值為Object
    DeptData: [String, Object]
  },
  components: {
    Multiselect
  },
  data () {
    return {
      vDeptId: '',
      options: [],
      DeptId: []
    }
  },
  watch: { // 監控數值
    DeptData () {
      if (this.DeptData === '') {
        this.vDeptId = ''
      } else {
        this.vDeptId = this.DeptData
      }
    },
    options () {
      if (this.options !== []) { // 當部門資料不為空時，透過 $bus & $emit 傳遞所有部門資料給父層
        this.$bus.$emit('AllDept', this.options)
      }
    }
  },
  created () { // 預先處理
    const vm = this
    if (vm.DeptData !== '') {
      vm.vDeptId = vm.DeptData
    } else {
      vm.vDeptId = ''
    }
    vm.PostDept()
  },
  methods: { // 呼叫函式
    onTouch () { // 傳遞給父層接收，使表格筆數變動
      this.$emit('SelectDept', this.vDeptId)
    },
    nameWithLang ({ DeptName }) {
      return `${DeptName}`
    },
    PostDept () { // 學校單位代碼對照表 P_API001
      // 定義資料
      const vm = this
      var NewData = {}
      NewData.APIVer = '0'
      NewData.ClientIP = ''
      NewData.IntegratedSysId = '255'
      NewData.Token = '9C2D3D654D8E495DBA5E38A0F8E20A32'
      // 呼叫API
      apiDeptid(NewData).then(
        res => {
          if (res !== undefined) {
            vm.options = res.Data
          }
        }
      )
    }
  }
}
</script>

<template>
  <multiselect
    id="DeptID"
    v-model="vDeptId"
    :options="options"
    :custom-label="nameWithLang"
    placeholder="請選擇單位或輸入關鍵字"
    label="DeptName"
    track-by="DeptId"
    @close="onTouch"
  />
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
.multiselect__tags {
  height: calc(1.5em + 0.75rem);
}
</style>
